'use client';

import Image from 'next/image';
import { pushEvent } from '@/lib/analytics/core';
import { ASK_AI_COPY } from '@/lib/marketing/messaging-bank';
import {
  ASK_AI_PROMPT_VERSION,
  ASK_AI_PROVIDERS,
  buildAskAiUrl,
  type AskAiProviderId,
} from '@/lib/seo/ask-ai-links';

export function AskAiEvaluation({ placement }: { placement: string }) {
  function track(provider: AskAiProviderId) {
    pushEvent('ai_assistant_prompt_clicked', {
      provider,
      placement,
      prompt_version: ASK_AI_PROMPT_VERSION,
      source_path: window.location.pathname,
    });
  }

  return (
    <section
      aria-labelledby={`ask-ai-heading-${placement}`}
      className="edge-2 surface-5 mx-auto my-12 w-[min(1120px,calc(100%-2rem))] rounded-3xl border px-5 py-8 text-center shadow-2xl shadow-black/10 sm:px-8"
    >
      <h2 id={`ask-ai-heading-${placement}`} className="text-2xl font-semibold tracking-tight text-white sm:text-3xl">
        {ASK_AI_COPY.heading}
      </h2>
      <p className="mx-auto mt-2 max-w-2xl text-sm leading-6 text-white/70 sm:text-base">
        {ASK_AI_COPY.body}
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        {ASK_AI_PROVIDERS.map((provider) => (
          <a
            key={provider.id}
            href={buildAskAiUrl(provider.baseUrl)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Ask ${provider.label} to evaluate BizRnR`}
            title={`Ask ${provider.label}`}
            onClick={() => track(provider.id)}
            className="edge-2 group flex min-h-20 min-w-20 flex-col items-center justify-center gap-2 rounded-2xl border bg-white px-3 py-3 text-xs font-semibold text-slate-900 shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-300"
          >
            {provider.icon ? (
              <Image src={provider.icon} alt="" width={30} height={30} aria-hidden="true" />
            ) : (
              <span aria-hidden className="flex size-[30px] items-center justify-center rounded-full bg-black text-sm font-bold text-white">G</span>
            )}
            <span>{provider.label}</span>
          </a>
        ))}
      </div>
      <p className="mx-auto mt-5 max-w-2xl text-xs leading-5 text-white/55">
        {ASK_AI_COPY.disclosure}
      </p>
    </section>
  );
}
